import { Action } from '@ngrx/store';
import { WarehouseLocation } from './warehouse-location.model';

export const ADD = '[WarehouseLocation] Add';
export const ADD_COMPLETE = '[WarehouseLocation] Add Complete';
export const ADD_FAILED = '[WarehouseLocation] Add Failed';

export const DELETE = '[WarehouseLocation] Delete';
export const DELETE_COMPLETE = '[WarehouseLocation] Delete Complete';
export const DELETE_FAILED = '[WarehouseLocation] Delete Failed';

export const LIST = '[WarehouseLocation] List By Division';
export const LIST_COMPLETE = '[WarehouseLocation] List Complete';
export const LIST_FAILED = '[WarehouseLocation] List Failed';

export const LIST_BY_STUDIO = '[WarehouseLocation] List By Studio';
export const LIST_BY_STUDIO_COMPLETE = '[WarehouseLocation] List By Studio Complete';
export const LIST_BY_STUDIO_FAILED = '[WarehouseLocation] List By Studio Failed';

export const SELECT = '[WarehouseLocation] Select';

export const UPDATE = '[WarehouseLocation] Update';
export const UPDATE_COMPLETE = '[WarehouseLocation] Update Complete';
export const UPDATE_FAILED = '[WarehouseLocation] Update Failed';

export class AddAction implements Action {
    readonly type = ADD;

    constructor(public payload: WarehouseLocation) { }
}

export class AddCompleteAction implements Action {
    readonly type = ADD_COMPLETE;

    constructor(public payload: WarehouseLocation) { }
}

export class AddFailedAction implements Action {
    readonly type = ADD_FAILED;

    constructor(public payload: { error: any }) { }
}

export class DeleteAction implements Action {
    readonly type = DELETE;

    constructor(public payload: WarehouseLocation) { }
}

export class DeleteCompleteAction implements Action {
    readonly type = DELETE_COMPLETE;

    constructor(public payload: WarehouseLocation) { }
}

export class DeleteFailedAction implements Action {
    readonly type = DELETE_FAILED;

    constructor(public payload: { error: any }) { }
}

export class ListAction implements Action {
    readonly type = LIST;

    constructor(public payload: number) { }
}

export class ListCompleteAction implements Action {
    readonly type = LIST_COMPLETE;

    constructor(public payload: WarehouseLocation[]) { }
}

export class ListFailedAction implements Action {
    readonly type = LIST_FAILED;

    constructor(public payload: { error: any }) { }
}

export class ListByStudioAction implements Action {
    readonly type = LIST_BY_STUDIO;

    constructor(public payload: number) { }
}

export class ListByStudioCompleteAction implements Action {
    readonly type = LIST_BY_STUDIO_COMPLETE;

    constructor(public payload: WarehouseLocation[]) { }
}

export class ListByStudioFailedAction implements Action {
    readonly type = LIST_BY_STUDIO_FAILED;

    constructor(public payload: { error: any }) { }
}

export class SelectAction implements Action {
    readonly type = SELECT;

    constructor(public payload: number) { }
}

export class UpdateAction implements Action {
    readonly type = UPDATE;

    constructor(public payload: WarehouseLocation) { }
}

export class UpdateCompleteAction implements Action {
    readonly type = UPDATE_COMPLETE;

    constructor(public payload: WarehouseLocation) { }
}

export class UpdateFailedAction implements Action {
    readonly type = UPDATE_FAILED;

    constructor(public payload: { error: any }) { }
}

export type Actions
    = AddAction
    | AddCompleteAction
    | AddFailedAction
    | DeleteAction
    | DeleteCompleteAction
    | DeleteFailedAction
    | ListAction
    | ListCompleteAction
    | ListFailedAction
    | ListByStudioAction
    | ListByStudioCompleteAction
    | ListByStudioFailedAction
    | SelectAction
    | UpdateAction
    | UpdateCompleteAction
    | UpdateFailedAction;
